module.exports = __webpack_public_path__ + "static/media/BANNERTOTOPAY.aecd9e43.png";